import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientContactsApiAdapter } from '../adapters/ClientContactsApiAdapter';

export const useTeamContacts = (teamId: number) => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientContactsApiAdapter(httpClient);
    }, []);

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['team-contacts', teamId],
        queryFn: async () => {
            const response = await apiAdapter.getContacts(teamId);
            return response;
        },
        staleTime: 2 * 60 * 1000, // 2 minutos
        enabled: !!teamId,
    });

    return {
        contacts: data?.data ?? [],
        isLoading,
        error,
        refetch,
    };
};

